import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import CategoriesMenu from '../components/categories/CategoriesMenu.vue';
import CategoriesList from '../components/categories/CategoriesList.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CategoriesMenu),
    _createVNode(CategoriesList)
  ], 64))
}
}

})